import React from 'react';

import type { Theme } from '@material-ui/core/styles';

import { appSelectors, type IAppState } from '@klp/core/app';

import { Main } from '@klp/layout/Main';
import { Box } from '@material-ui/core';
import { Block, Heading, Typography, ActionButton } from '@klp/design';

import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { useSelector } from 'react-redux';

const styles = (theme: Theme) => ({
    errorContainer: {
        height: '100%',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexDirection: 'column',
    },
    errorContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '50%',
        gap: theme.spacing(1),
    },
});

export type ErrorHandlerProps = IAppState;

export const ErrorHandler: React.FC<React.PropsWithChildren<unknown>> = ({
    children,
}) => {
    const { error } = useSelector(appSelectors);

    const classes = useKlpStyles({}, styles);

    if (!error) {
        return <>{children}</>;
    }

    return (
        <Main>
            <Block className={classes.errorContainer}>
                <Box className={classes.errorContent}>
                    <Heading klpHeadingLevel="ONE">
                        {typeof error === 'object' ? error.message : 'Oops!'}
                    </Heading>
                    <Typography
                        variant="h5"
                        translation="general.error.message"
                    />
                    <ActionButton
                        actionType="button"
                        translation="general.error.reloadPage"
                        onClick={() => window.location.reload()}
                    />
                </Box>
            </Block>
        </Main>
    );
};
